module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_VIMEO_red-78eecb7c938df457c149e4fee122f480.svg";